var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.02 35.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "plus-1",
    d: "M32.14,14.63h-11.74V2.88C20.39,1.29,19.1,0,17.51,0s-2.88,1.29-2.88,2.88v11.74H2.88C1.29,14.63,0,15.92,0,17.51s1.29,2.88,2.88,2.88h11.74v11.74c0,1.59,1.29,2.88,2.88,2.88s2.88-1.29,2.88-2.88v-11.74h11.74c1.59,0,2.88-1.29,2.88-2.88s-1.29-2.88-2.88-2.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus34);
export default __webpack_public_path__ + "static/media/plus-34.bff15232f91dd71d7cfe7bb632bd3460.svg";
export { ForwardRef as ReactComponent };